import React, { useEffect } from 'react'
import PreviewHeader from './PreviewHeader'
import { useDispatch, useSelector } from 'react-redux';
import { getLoading, setConfig, setLoading, setSteps } from '../../../redux/walkthroughPreviewSlice';
import { API_ENDPOINTS } from '../utils/endpoints';
import { http_get } from '../utils/api_client';
import Loader from '../../organisms/loader/Loader';
import { getMaterial, setMaterial } from '../../../redux/materialSlice';
import StepViewer from './StepViewer';
import { setProfileData } from '../../../redux/profileSlice';
import { fetchCompanyDetails } from '../../../redux/companySlice';
import { getValue } from '../utils/tools';

const EditPagePreview = ({ id, current_user }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => getLoading(state));
  const material = useSelector((state) => getMaterial(state));
  const { config } = material;

  const defaultColors = {
    background: '#F6F8F9',
    config
  };

  const baBGColor = getValue(defaultColors, 'ba', 'baHeaderColor');
  const previewSurfaceStyle = {
    '--path-bottom-bg': baBGColor || '#F6F8F9',
    '--path-bottom-bg-end': baBGColor || '#F6F8F9'
  };

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(setProfileData(current_user));
    dispatch(fetchCompanyDetails());
    const url = `${API_ENDPOINTS.GET_LEARNING_MATERIALS}/${id}`;

    http_get(url)
      .then(({ data }) => {
        const config = data.config;
        const steps = data.data;
        dispatch(setSteps(steps));
        dispatch(setConfig(config));
        dispatch(setMaterial(data));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  }, []);

  return (
    <>
      {isLoading ?
        <Loader />
        :
        <div className="un-path-public-page" style={previewSurfaceStyle}>
          <PreviewHeader forcePublicView />
          <StepViewer />
        </div>
      }
    </>
  )
}

export default EditPagePreview
